var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"task-list"},[_c('page-list',{attrs:{"list":_vm.list,"columns":_vm.columns,"export-data-options":_vm.exportDataOptions,"group-actions":_vm.groupActions}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }